import request from '@/utils/request'

// 查询短信通知手机号列表
export function querySmsNoticeList(query) {
    return request({
        url: '/share-car-manager/mobile/mobiles',
        method: 'get',
        params: query
    })
}

// 更新短信通知手机号
// 事故电话--type-0
export function updateSmsNotice(data) {
    return request({
        url: '/share-car-manager/mobile/addMobiles',
        method: 'post',
        data: data
    })
}

